import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'lma-shipmentbased.TA.valuable.count.total',
  hidden: true,
  positiveDirection: PositiveDirection.custom,
  label: 'Wertsendungen auf Tour inkl. nicht gestartet',
  definition: getDefinitionByName('Wertsendungen auf Tour'),
});
